import PropTypes from "prop-types";
import moment from "moment";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "../styles/discountDetailTooltip.css";
import { moneyFormat } from "../untils/constanst";

const formatPeriod = (startPeriod, endPeriod) => {
	const start = moment(startPeriod, "YYYY/MM/DD HH:mm:ss", true);
	const end = moment(endPeriod, "YYYY/MM/DD HH:mm:ss", true);

	if (start.isValid() && end.isValid()) {
		return `${start.format("HH:mm")} - ${end.format("HH:mm DD/MM")}`;
	}

	return `${startPeriod || ""} - ${endPeriod || ""}`;
};

const formatHours = (hours) => {
	const value = Number(hours);
	if (!Number.isFinite(value)) {
		return "";
	}

	return `${Number.isInteger(value) ? value : value.toFixed(1)} giờ`;
};

const formatMoney = (value) => {
	const number = Number(value);
	if (!Number.isFinite(number)) {
		return "0";
	}

	return moneyFormat(number);
};

export const getStepBasePrice = (step = {}) => {
	const amount = Number(step?.amount);
	const percent = Number(step?.percent || 0);

	if (Number.isFinite(amount)) {
		if (percent > 0 && percent < 100) {
			return Math.round(amount / (1 - percent / 100));
		}

		return amount;
	}

	return Number(step?.price || 0);
};

export const getStepPriceDescription = (step = {}) => {
	const basePrice = `${formatMoney(getStepBasePrice(step))} VND`;
	const percent = Number(step?.percent || 0);

	if (percent > 0) {
		return `${basePrice} giảm ${step?.percent}% còn ${formatMoney(step?.amount)} VND`;
	}

	return basePrice;
};

export const getPriceSummary = (steps = []) =>
	steps.reduce(
		(summary, step) => {
			const basePrice = Number(getStepBasePrice(step));
			const amount = Number(step?.amount);

			if (Number.isFinite(basePrice)) {
				summary.price += basePrice;
			}

			if (Number.isFinite(amount)) {
				summary.priceAfterDiscount += amount;
			}

			summary.discount = summary.price - summary.priceAfterDiscount;
			return summary;
		},
		{ price: 0, priceAfterDiscount: 0, discount: 0 },
	);

const DiscountDetailTooltip = ({ discountDetail, tooltipId }) => {
	const periods = Array.isArray(discountDetail?.map_price_rs)
		? discountDetail.map_price_rs
		: [];
	const tooltipSummary = getPriceSummary(
		periods.flatMap((period) =>
			Array.isArray(period?.step_detail) ? period.step_detail : [],
		),
	);

	if (tooltipSummary.discount <= 0 || periods.length === 0) {
		return null;
	}

	return (
		<>
			<span
				aria-label="Xem chi tiết giảm giá"
				className="discount-detail-trigger"
				data-tooltip-id={tooltipId}
				role="button"
				tabIndex={0}
			>
				?
			</span>
			<ReactTooltip
				id={tooltipId}
				place="top"
				type="info"
				variant="info"
				effect="float"
				clickable
				openOnClick
				className="info-order-discount-tooltip"
			>
				<div className="discount-tooltip-content">
					<div className="discount-tooltip-summary">
						<div>
							<span>Tổng tiền gốc</span>
							<strong>{formatMoney(tooltipSummary.price)} VND</strong>
						</div>
						<div>
							<span>Giảm giá</span>
							<strong>-{formatMoney(tooltipSummary.discount)} VND</strong>
						</div>
						<div>
							<span>Cần thanh toán</span>
							<strong>
								{formatMoney(tooltipSummary.priceAfterDiscount)} VND
							</strong>
						</div>
					</div>
					{periods.map((period, periodIndex) => {
						const steps = Array.isArray(period?.step_detail)
							? period.step_detail
							: [];
						const periodSummary = getPriceSummary(steps);

						return (
							<div className="discount-tooltip-period" key={periodIndex}>
								<div className="discount-tooltip-period-title">
									<strong>
										{formatPeriod(period?.start_period, period?.end_period)}
									</strong>
									<span>
										{formatMoney(periodSummary.price)} VND -{" "}
										{formatMoney(periodSummary.priceAfterDiscount)} VND
									</span>
								</div>
								{steps.map((step, stepIndex) => (
									<div className="discount-tooltip-step" key={stepIndex}>
										<span>
											Giờ {step?.hour}: {formatHours(step?.hours)}
										</span>
										<span>
											{getStepPriceDescription(step)}
										</span>
									</div>
								))}
							</div>
						);
					})}
				</div>
			</ReactTooltip>
		</>
	);
};

DiscountDetailTooltip.propTypes = {
	discountDetail: PropTypes.object,
	tooltipId: PropTypes.string.isRequired,
};

export default DiscountDetailTooltip;
